import React from 'react';
import styles from './StatsBar.module.css';
import { useStaggerAnimation } from '../hooks/useScrollAnimation';

const STATS = [
  { num: '430', suffix: 'M+', label: 'Monthly Reddit users' },
  { num: '100', suffix: '%', label: 'Human-operated accounts' },
  { num: '6', suffix: 'mo+', label: 'Minimum account age' },
  { num: '24', suffix: 'hr', label: 'Delivery start time' },
];

export default function StatsBar() {
  const ref = useStaggerAnimation();

  return (
    <div className={styles.bar}>
      <div className="container">
        <div className={styles.grid} ref={ref}>
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className={`${styles.item} stagger-child`}
              style={{ borderRight: i < STATS.length - 1 ? '1px solid var(--border)' : 'none' }}
            >
              <div className={styles.num}>
                {s.num}
                <span className={styles.suffix}>{s.suffix}</span>
              </div>
              <div className={styles.label}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
